import { useLocation } from 'react-router-dom'

/* Return current location.pathname + location.search*/
export default function useGetCurrPath() {
  const location = useLocation()
  return location.pathname + location.search
}
